import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, message,Icon } from 'antd';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';
import Update from './Update';
import AdjustRequirement from './components/AdjustRequirement';
import EmployeeDetail from './components/EmployeeDetail';
import ExportModal from './components/ExportModal';
import FteDetail from './components/FteDetail';
import ProcessDetail from './components/ProcessDetail';
import ProcessRequirement from './components/ProcessRequirement';
import RequireRemark from './components/RequireRemark';
import UserDistribute from './components/UserDistribute';
import UserSider from '../UserSider';
import MemberSider from '../../member/MemberSider';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import cellRenderEnhancer from '../../shared/cellRenderEnhancer';
import renderEnhancer from '../../shared/renderEnhancer';
import genOperationAuth from '../../common/genOperationAuth';
import { AcquireStatus, RequirementType, Status, Default, Storage, genStorage, includes, RequirementTypeInInvType } from './constants';
import { actions } from '../../../actions/researchCenter/detail';

const Limit = 10;

class Require extends Component {
    constructor(props) {
        super(props);
        genStorage();

        const { match } = props;
        const { params: { requireId = '' } = {} } = match || {};
        this.requireId = requireId;

        this.state = {
            sortParams: {},
            searchParams: {},
            data: [],
            pagination: {
                current: 1,
            },
            loading: false,
            allowCreate: false,
            canAdd: false,
            planBeginTime: null,
            planEndTime: null,
            isGivenSecondLines: false,
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationSecondLines();
        // 项目内（非总览）预取项目阶段；点击处理等操作仍走 queryInvestigationStageByInvId 实时校验
        !Storage.isTotal && dictCache.getDict(`INV_STAGE_${Storage.invId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.investigation.queryInvestigationStageByInvId,
                data: { investigationId: Storage.invId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ invStageList: res.data });
        });
    }
    download = (vitaeId) => {
        ExportUtil.export({ vitaeId, typeName: 'DOCX' }, null, API_URL.personal.downloadVitaeByType);
        message.success('正在下载中!')
    };
    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { investigationMedicineType = [] } = searchParams;
        const { current } = pagination;
        this.setState({ loading: true });

        const options = {
            method: 'POST',
            url: API_URL.member.listRequireMents,
            data: {
                invId: Storage.invId,
                offset: current,
                limit: Limit,
                invRoleCode: Storage.curRole,
                requirementId: this.requireId,
                requirementType: 'InvestigationRequest',
                ...sortParams,
                ...searchParams,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
            },
            type: 'json',
            doneResult: res => {
                const {
                    requirementList,
                    allowCreate,
                    canAdd,
                    planBeginTime = null,
                    planEndTime = null,
                } = res.data;
                const { datas, totalCount } = requirementList || {};
                const data = this.parseData(datas);
                const pageSize = data.length;
                const integer = Math.floor(totalCount / Limit);
                const remainder = totalCount % Limit;
                
                pagination.pageSize = pageSize > Limit ? pageSize : Limit;
                pagination.total = pageSize > Limit ? integer * pageSize + remainder : totalCount;

                this.requireId = '';
                this.setState({
                    data,
                    pagination,
                    allowCreate,
                    canAdd,
                    planEndTime,
                    planBeginTime,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                this.setState({
                    isGivenSecondLines,
                });
            }
        };
        !!invId && $.sendRequest(options);
    }

    parseData = (datas) => {
        const data = [];

        (datas || []).forEach(i => {
            const { childList } = i;
            // 启动前+启动后
            /**
             * 启动前、启动后
             * 1、转换数据格式
             * 
             * 启动前+启动后
             * 1、是同一人
             *   1.1、合并单元格
             *   1.2、转换数据格式&合并
             * 2、不是同一人
             *   2.1、转换数据格式
             */
            if (childList.length === 2) {
                const [f, s] = childList;

                f.requirementInfo = f.requirementInfo || {};
                f.requirementInfo.requirementId = f.requirementId;
                f.requirementInfo.comment = f.requirementComment;
                s.requirementInfo = s.requirementInfo || {};
                s.requirementInfo.requirementId = s.requirementId;
                s.requirementInfo.comment = s.requirementComment;

                const fType = RequirementTypeInInvType[f.requirementInfo.requirementInfoType];
                const sType = RequirementTypeInInvType[s.requirementInfo.requirementInfoType];
                f.requirementInfos = {
                    [fType]: f.requirementInfo,
                    [sType]: s.requirementInfo,
                };
                s.requirementInfos = {
                    [fType]: f.requirementInfo,
                    [sType]: s.requirementInfo,
                };

                // 是同一人，合并操作栏
                if (f.afterBeforeStartupSameMember === 1) {
                    f.rowSpan = 2;
                    s.rowSpan = 0;
                } else {
                    // 标识修改时要显示的需求类型
                    f.requirementInfos.current = fType;
                    s.requirementInfos.current = sType;
                }
            } else if (childList.length) {
                const [f] = childList;

                f.requirementInfo = f.requirementInfo || {};
                f.requirementInfo.requirementId = f.requirementId;
                f.requirementInfo.comment = f.requirementComment;
                
                const fType = RequirementTypeInInvType[f.requirementInfo.requirementInfoType];
                f.requirementInfos = {
                    [fType]: f.requirementInfo,
                };
            }
            data.push(...childList);
        });

        return data;
    }

    export = () => {
        const { searchParams, pagination, sortParams } = this.state;

        if (Storage.isTotal) {
            return this.exportRef.show(searchParams);
        }

        const params = {
            ...sortParams,
            ...searchParams,
            requirementType: "InvestigationRequest"
        };
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type: "PLAN_REQ" },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                params.asynchronousExportId = asynchronousExportId;
                ExportUtil.export(params, pagination, API_URL.member.export);
            },
            errorResult: (() => {
                this.setState({ loading: false });
            })
        };
        $.sendRequest(options);
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        const { areaParams = {}, hasCheckedArea, ...rest } = params;
        this.setState({
            pagination,
            searchParams: { ...areaParams, ...rest }
        }, () => {
            this.loadData();
        });
    }

    cancel = requirementId => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: '确认撤销该条需求记录？',
            onOk: () => {
                $.sendRequest({
                    url: API_URL.member.revokeRequirement,
                    data: { requirementId },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    }
                });
            }
        });
    }

    delete = record => {
        const { afterBeforeStartupSameMember, requirementId } = record;
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: <div style={{ marginLeft: 42 }}>请确认是否需要删除该条需求记录？</div>,
            content: afterBeforeStartupSameMember == '1' ? '需求编号下有多条需求记录时，将一并删除多条需求' : null,
            onOk: () => {
                const options = {
                    url: API_URL.member.deleteRequireMents,
                    data: { requirementId },
                    dataType: 'json',
                    doneResult: () => {
                        message.success('删除成功');
                        this.loadData();
                    },
                };
                $.sendRequest(options);
            }
        });
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                }, () => {
                    callback && this.canEditByInvStatus(callback);
                });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { canAdd } = this.state;

        const columns = [{
            title: '需求编号',
            dataIndex: 'requirementCode',
            key: 'requirementCode',
            fixed: 'left',
            sorter: true,
            width: 100,
            render: cellRenderEnhancer({
                renderContent: (record) => record.handoverCode
            })(),
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            sorter: true,
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            sorter: true,
            width: 200,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 160,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineName',
            key: 'investigationMedicineName',
            sorter: true,
            width: 140,
        }, {
            title: '项目分期',
            dataIndex: 'investigationByStageName',
            key: 'investigationByStageName',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'investigationSponsor',
            key: 'investigationSponsor',
            width: 200,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
            width: 100,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            width: 200,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 200,
        },{
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 200,
        },{
            title: '医院主管工号',
            dataIndex: 'hospitalDirectorCode',
            key: 'hospitalDirectorCode',
            width: 100,
        }, {
            title: '医院主管姓名',
            dataIndex: 'hospitalDirectorName',
            key: 'hospitalDirectorName',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'city',
            key: 'city',
            width: 80,
        }, {
            title: 'PI',
            dataIndex: 'piUserNames',
            key: 'piUserNames',
            width: 80,
        }, {
            title: '项目获得状态',
            dataIndex: 'investigationAcquisitionStatus',
            key: 'investigationAcquisitionStatus',
            width: 100,
            render: (text) => AcquireStatus[text] || '',
        }, {
            title: '需求来源',
            dataIndex: 'requirementOriginShow',
            key: 'requirementOriginShow',
            width: 80,
        }, {
            title: '需求类型',
            dataIndex: 'requirementInfoType',
            key: 'requirementInfoType',
            width: 100,
            render: (text) => (text || '').split(',').map(i => RequirementType[i]).join('，'),
        }, {
            title: '启动前后是否要求同一人',
            dataIndex: 'afterBeforeStartupSameMember',
            key: 'afterBeforeStartupSameMember',
            width: 100,
            render: (text) => Default[text] || '',
        }, {
            title: '目前项目进度',
            dataIndex: 'currentInvestigationProgress',
            key: 'currentInvestigationProgress',
            width: 200,
        }, {
            title: '预计上岗时间',
            dataIndex: 'planOnDutyTime',
            key: 'planOnDutyTime',
            sorter: true,
            width: 120,
            render: text => format('date', text),
        }, {
            title: '预计/实际启动时间',
            dataIndex: 'planStartupTime',
            key: 'planStartupTime',
            sorter: true,
            width: 100,
            render: text => format('date', text),
        }, {
            title: 'FTE需求',
            dataIndex: 'fteTotalShow',
            key: 'fteTotalShow',
            width: 80,
            render: (text, record) => {
                const { requirementOrigin, status } = record
                return (
                    (requirementOrigin === 'HANDOVER' && status === 'NEW') ?
                        ''
                    :
                        <a onClick={() => this.showFteDetail(record)}>{text}</a>
                );
            }
        }, {
            title: '人员要求',
            dataIndex: 'requirementComment',
            key: 'requirementComment',
            width: 160,
        }, {
            title: '发起人',
            dataIndex: 'requireUser',
            key: 'requireUser',
            width: 80,
        }, {
            title: '被分配人员',
            dataIndex: 'assignedUsers',
            key: 'assignedUsers',
            width: 120,
            render: (text, record) => {
                if (record.assignedUsers) {
                    let users = record.assignedUsers.split('//');
                    return (
                        <span>
                            {
                                users.map((user, i) => {
                                    let u = user.split(',');
                                    return (
                                        <div>
                                            <a onClick={() => this.showEmployeeDetail(u[0], u[1], u[2])}>
                                            {u[2]}{users.length > 1 ? ';' : ''}
                                        </a>
                                        {
                                            u[3]?u[3]>0?<Icon type="paper-clip" style={{color: '#ffbf00', cursor: 'pointer' ,padding:'0 5px'}} onClick={() => this.download(u[3])}/>:'':''
                                        }
                                        </div>
                                        
                                    );
                                })
                            }
                        </span>
                    )
                };
            }
        }, {
            title: '处理人',
            dataIndex: 'assignUserName',
            key: 'assignUserName',
            width: 80,
        }, {
            title: '是否满足处理速度',
            dataIndex: 'satisfiedDealSpeed',
            key: 'satisfiedDealSpeed',
            width: 120,
            render: (text) => Default[text] || '-',
        }, {
            title: '人员到位后是否有效利用',
            dataIndex: 'effectiveUse',
            key: 'effectiveUse',
            width: 100,
            render: (text) => Default[text] || '-',
        }, {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 80,
            render: text => Status[text] || '未知',
        }, {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 160,
            render: renderEnhancer((text, record) => {
                const { status, requirementId, cityId, provinceId, investigationId, requirementOrigin, requirementInfos, assignedUsers, unblindingRisk, unblindingRiskLevel } = record;
                const { isGivenSecondLines } = this.state;
                const params = { workCityId: cityId, provinceId, requirementId, investigationId, requirementInfos, unblindingRisk, unblindingRiskLevel };
                const PA_PM = includes(['PM', 'PA'], Storage.curRole);
                const fromRequire = requirementOrigin === 'CREATE';
                const fromTransfer = requirementOrigin === 'HANDOVER';
                const hasAssignUser = (assignedUsers || []).length > 0;
                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: status === "NEW" && !Storage.isTotal && !fromTransfer,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.update(record, 'edit')),
                        roles: ['PA', 'PM'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: (status === "NEW" || status === 'REJECTED') && !Storage.isTotal && !fromTransfer,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.delete(record)),
                        roles: ['PA', 'PM'],
                    }],
                    ['rehandle', {
                        name: status === "NEW" ? '处理' : '重新处理',
                        display: (status === "NEW" || status === 'REJECTED') && (!PA_PM || (PA_PM && Storage.isTotal)) && !fromTransfer,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.queryInvestigationStageByInvId(investigationId, () => this.processRequirement(params, status === "NEW" ? "handle" : 'rehandle'))),
                        roles: ['CRCC', 'CRCM', 'BO', 'PA', 'PM', 'CSAL'],
                    }],
                    ['distribute', {
                        name: '处理人员分配',
                        display: (status === 'ASSIGNED' || status === 'REASSIGNED') && !Storage.isTotal && !fromTransfer,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.handleDistribute(params)),
                        roles: ['PA', 'PM'],
                    }],
                    ['reContribute', {
                        name: '重新分配',
                        display: status === 'ACTIVE' && !fromTransfer,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.queryInvestigationStageByInvId(investigationId, () => this.processRequirement(params, "reContribute"))),
                        roles: ['CRCC', 'CRCM', 'BO', 'CSAL'],
                    }],
                    ['adjust', {
                        name: '调整需求',
                        // display: status === 'ACTIVE' && !Storage.isTotal,
                        
                        display: isGivenSecondLines ? false : (status === 'ACTIVE' && !Storage.isTotal),
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.adjustRequirement(record)),
                        roles: ['PA', 'PM'],
                    }],
                    ['cancel', {
                        name: '撤销需求',
                        display: (status === 'ACTIVE' || status === 'ASSIGNED' || status === 'REASSIGNED') && !Storage.isTotal && !fromTransfer,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.cancel(requirementId)),
                        roles: ['PA', 'PM'],
                    }],
                    ['copy', {
                        name: '复制新建',
                        display: !Storage.isTotal && canAdd && fromRequire,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.update(record, 'copy')),
                        roles: ['PA', 'PM'],
                    }],
                    ['supply', {
                        name: '人员补充',
                        display: status === 'ACTIVE' && fromRequire && !Storage.isTotal,
                        editable: true,
                        event: () => this.canEditByInvStatus(() => this.queryInvestigationStageByInvId(investigationId, () => this.update(record, 'supply'))),
                        roles: ['PA', 'PM'],
                    }],
                    ['detail', {
                        name: '查看分配明细',
                        display: (status !== 'NEW' && status !== 'REJECTED') || (status === 'REJECTED' && hasAssignUser),
                        editable: true,
                        event: () => this.showProcessDetail(requirementId),
                        roles: ['*'],
                    }],
                ]);
                return genOperationAuth(operationCorrespondRoles, Storage.curRole);
            }),
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = (data || []).map(item => {
            const { site, fteList, requirementInfo, requirementInfoType, leaderNameCode, areaName, ...rest } = item;
            const { city, cityId, provinceId, investigationSiteCode, investigationSiteName, investigation, courtyardArea,departmentName  } = site || {};
            return {
                ...requirementInfo,
                ...rest,
                ...investigation,
                areaName,
                requirementInfo,
                leaderNameCode,
                city,
                cityId,
                provinceId,
                investigationSiteCode,
                investigationSiteName,
                courtyardArea,
                departmentName
            };
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        const { sortParams } = params;
        if (sortParams.sort == 'investigationMedicineName') {
            sortParams.sort = 'investigationMedicineType';
        }
        this.setState(params, () => {
            this.loadData();
        });
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }
    
    adjustRequirement = (record) => {
        this.adjustRef.show(record);
    }

    handleDistribute = (params) => {
        this.canEditByInvStatus(() => this.userDistributeRef.show(params));
    }

    showFteDetail = (record) => {
        this.fteDetailRef.show(record);
    }

    processRequirement = (params, type) => {
        this.processRef.show(params, type);
    }

    showProcessDetail = id => {
        this.processDetailRef.show(id);
    }

    showEmployeeDetail = (id, code, name) => {
        this.employeeDetailRef.show(id, code, name);
    }

    showRequireRemark = (editable) => {
        this.requireRemarkRef.show(editable);
    }

    relate = (params) => {
        const { investigationSiteCode } = params;
        this.props.saveSearchParams({ siteCode: investigationSiteCode });
        sessionStorage.setItem('siteId', '0');
        sessionStorage.setItem('investigationSiteName', '');
        location.href = '/#/site/detail';
    }

    render() {
        const { loading, pagination, allowCreate, canAdd, planBeginTime, planEndTime, sortParams } = this.state;
        const yscroll = document.documentElement.clientHeight - 190;
        return (
            <div className="content">
                {
                    Storage.isTotal ?
                        <UserSider selectKey='userRequire' openKeys={['sub1']}/>
                    :
                        <MemberSider selectKey='memberRequire' />
                }
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                        allowCreate={allowCreate}
                        canAdd={canAdd}
                        update={this.update}
                        showRequireRemark={this.showRequireRemark}
                        canEditByInvStatus={this.canEditByInvStatus}
                    />
                    <TableC
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        className="require"
                        rowKey="requirementId"
                        onChange={this.handleTableChange}
                        pagination={pagination}
                        scrollY={yscroll}
                    />
                </div>
                <Update
                    ref={el => this.updateRef= el}
                    planEndTime={planEndTime}
                    planBeginTime={planBeginTime}
                    relate={this.relate}
                    loadData={this.loadData}
                />
                <AdjustRequirement
                    ref={el => this.adjustRef= el}
                    planEndTime={planEndTime}
                    planBeginTime={planBeginTime}
                    loadData={this.loadData}
                />
                <FteDetail ref={el => this.fteDetailRef = el} />
                <ProcessRequirement
                    loadData={this.loadData}
                    ref={el => this.processRef = el}
                    showEmployeeDetail={this.showEmployeeDetail}
                />
                <UserDistribute
                    loadData={this.loadData}
                    ref={el => this.userDistributeRef = el }
                    showEmployeeDetail={this.showEmployeeDetail}
                />
                <EmployeeDetail ref={el => this.employeeDetailRef = el} />
                <ProcessDetail ref={el => this.processDetailRef = el} />
                <RequireRemark ref={el => this.requireRemarkRef = el} />
                <ExportModal ref={el => this.exportRef = el} />
            </div>
        );
    }
}

export default connect(null, actions)(Require);



// WEBPACK FOOTER //
// ./src/components/user/require/index.js